import ImgLogo from "../assets/images/logo_horizontal.png";

export const settings = {
  websiteName: "https://digibuddy.fr/",
  compagnieName: "Digibuddy",
  storageDirFromScript: "../storage/", //"../../storage",
  // scriptsDir: "http://localhost/digibuddy/scripts/",
  // scriptsDir: "https://digibuddy.fr/scripts/",
  scriptsDir: "/scripts/",
  adminPassword: "ISMvKXpXpadDiUoOSoAfww==",
  timestamp: 1711920000,
  rdvLink: "https://calendly.com/vdeliencourt-digibuddy/30min",
  navbar: {
    height: "60px", // 5rem
    backgroundColor: "white",
    fontColor: "black",
    logoImg: <img src={ImgLogo} alt="logo" />,
    logoPosition: "left",
  },
  pages: {
    pageMaxWidth: "800px",
    accueil: {
      title: "Accueil",
      position: "right",
    },
    process: {
      title: "Méthode",
      position: "right",
    },
    offres: {
      title: "Offres",
      position: "right",
      sub: {
        web: {
          title: "Création de site web",
          href: "/creation-site-web-sur-mesure",
        },
        mobile: {
          title: "Application mobile",
          href: "/developpement-application-mobile",
        },
        logicielWeb: {
          title: "Logiciel métier",
          href: "/logiciel-metier-sur-mesure",
        },
        logicielBureau: {
          title: "Logiciel de bureau",
          href: "/logiciel-de-bureau-sur-mesure",
        },
      },
    },
    projets: {
      title: "Réalisations",
      position: "right",
    },
    faq: {
      title: "FAQ",
      position: "right",
    },
    contact: {
      title: "Contact",
      position: "right",
    },
  },
  footer: {
    logo: "/logo.png",
    description: "Votre compagnon digital<br/>dans vos projets.",
    address: "8 impasse Mathieu<br/>75015 Paris",
    phone: "<a href='tel:0640538176'>06 40 53 81 76</>",
    email: "<a href='mailto:contact@digibuddy.fr'>contact@digibuddy.fr</>",
    links: [
      { label: "Accueil", href: "/" },
      { label: "Méthode", href: "/#process" },
      { label: "Offres", href: "/#offres" },
      { label: "Sites web", href: "/creation-site-web-sur-mesure" },
      {
        label: "Applications mobiles",
        href: "/developpement-application-mobile",
      },
      { label: "Logiciels web", href: "/logiciel-metier-sur-mesure" },
      { label: "Logiciels de bureau", href: "/logiciel-de-bureau-sur-mesure" },
      {
        label: "Prix site web 2026",
        href: "/combien-coute-site-web-sur-mesure",
      },
      {
        label: "Freelance ou agence ?",
        href: "/freelance-ou-agence-pour-creer-son-site",
      },
      {
        label: "Freelance web Paris",
        href: "/developpeur-web-freelance-paris",
      },
      { label: "FAQ", href: "/#faq" },
      { label: "Contact", href: "/#contact" },
    ],
  },
};
